import React from "react";
import PicoLogoSvg from "./PicoLogo.svg?react";

interface PicoLogoProps {
  size?: number;
}

const DEFAULT_SIZE = 20;

const PicoLogo: React.FC<PicoLogoProps> = ({ size = DEFAULT_SIZE }) => (
  <PicoLogoSvg width={size} height={size} aria-hidden="true" />
);

export default PicoLogo;
